import FormGroupElement from "./FormGroupElement";

class Input extends FormGroupElement {

    render() {
        let className: string = "form-group" + (this.props?.pullRight ? " pull-right" : "");

        if (this.props?.defaultRef) {
            const ref = this.props?.defaultRef;
            return (
                <div className={className}>
                    {this.props?.skipLabel !== true && this.createLabel()}
                    <input {...this.prepareProps()} ref={ref}/>{this.createHelp()}
                </div>
            );
        }
        return (
            <div className={className}>
                {this.props?.skipLabel !== true && this.createLabel()}<input {...this.prepareProps()}/>{this.createHelp()}
            </div>
        );
    }

    protected prepareProps(): {} | any {
        let props = super.prepareProps();
        if (!props?.type) {
            props.type = "text";
        }

        props?.skipLabel && delete props.skipLabel;
        props?.pullRight && delete props.pullRight;
        props?.defaultRef && delete props.defaultRef;

        return props;
    }
}

export default Input;
